export default "__VITE_ASSET__BN1uu4Z0__"